export const INDIVIDUAL_PLAN_NAME = 'Family & Friends';
export const ENTERPRISE_PLAN_NAME = 'Schools & Beyond';
export const PRODUCTS = [
    {
        name: INDIVIDUAL_PLAN_NAME,
        description: 'Annual or Semi-annual Subscription',
        prices: [
            {
                unit_amount: 5900,
                nickname: 'Annual: Elementary (3rd-5th)',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_ELEMENTARY_3-5'
            },
            {
                unit_amount: 9900,
                nickname: 'Annual: Middle School (6th-8th)',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_MIDDLE_SCHOOL_6-8'
            },
            {
                unit_amount: 9900,
                nickname: 'Annual: High School (9th-12th)',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_HIGH_SCHOOL_9-12'
            },
            {
                unit_amount: 3999,
                nickname: 'SemiAnnual: Elementary (3rd-5th)',
                currency: 'usd',
                recurring: {
                    interval: 'month',
                    interval_count: 6
                },
                lookup_key: 'SEMI_ANNUAL_ELEMENTARY_3-5'
            },
            {
                unit_amount: 6499,
                nickname: 'SemiAnnual: Middle School (6th-8th)',
                currency: 'usd',
                recurring: {
                    interval: 'month',
                    interval_count: 6
                },
                lookup_key: 'SEMI_ANNUAL_MIDDLE_SCHOOL_6-8'
            },
            {
                unit_amount: 6499,
                nickname: 'SemiAnnual: High School (9th-12th)',
                currency: 'usd',
                recurring: {
                    interval: 'month',
                    interval_count: 6
                },
                lookup_key: 'SEMI_ANNUAL_HIGH_SCHOOL_9-12'
            }
        ]
    },
    {
        name: ENTERPRISE_PLAN_NAME,
        description: 'Annual Subscription',
        prices: [
            {
                unit_amount: 1500,
                nickname: 'Annual: 50-499',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_50-499'
            },
            {
                unit_amount: 1250,
                nickname: 'Annual: 500-999',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_500-999'
            },
            {
                unit_amount: 1000,
                nickname: 'Annual: 1000-2499',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_1000-2499'
            },
            {
                unit_amount: 750,
                nickname: 'Annual: 2500-4999',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_2500-4999'
            },
            {
                unit_amount: 500,
                nickname: 'Annual: 5000+',
                currency: 'usd',
                recurring: {
                    interval: 'year'
                },
                lookup_key: 'ANNUAL_5000+'
            }
        ]
    }
];
export const ENTERPRICE_PRICE_RANGES = {
    499: {
        lookup_key: 'ANNUAL_50-499'
    },
    999: {
        lookup_key: 'ANNUAL_500-999'
    },
    2499: {
        lookup_key: 'ANNUAL_1000-2499'
    },
    4999: {
        lookup_key: 'ANNUAL_2500-4999'
    },
    Infinity: {
        lookup_key: 'ANNUAL_5000+'
    }
};
export const ENTERPRICE_PRICE_RANGES_DATA = [
    {
        price: 15,
        min: 50,
        max: 499,
        lookup_key: 'ANNUAL_50-499'
    },
    {
        price: 12.5,
        min: 500,
        max: 999,
        lookup_key: 'ANNUAL_500-999'
    },
    {
        price: 10,
        min: 1000,
        max: 2499,
        lookup_key: 'ANNUAL_1000-2499'
    },
    {
        price: 7.5,
        min: 2500,
        max: 4999,
        lookup_key: 'ANNUAL_2500-4999'
    },
    {
        price: 5,
        min: 5000,
        max: Infinity,
        lookup_key: 'ANNUAL_5000+'
    }
];
export const INDIVIDUAL_ANNUAL_PRICE_RANGES = {
    ELEMENTARY: {
        lookup_key: 'ANNUAL_ELEMENTARY_3-5'
    },
    MIDDLE_SCHOOL: {
        lookup_key: 'ANNUAL_MIDDLE_SCHOOL_6-8'
    },
    HIGH_SCHOOL: {
        lookup_key: 'ANNUAL_HIGH_SCHOOL_9-12'
    }
};
export const INDIVIDUAL_SEMI_ANNUAL_PRICE_RANGES = {
    ELEMENTARY: {
        lookup_key: 'SEMI_ANNUAL_ELEMENTARY_3-5'
    },
    MIDDLE_SCHOOL: {
        lookup_key: 'SEMI_ANNUAL_MIDDLE_SCHOOL_6-8'
    },
    HIGH_SCHOOL: {
        lookup_key: 'SEMI_ANNUAL_HIGH_SCHOOL_9-12'
    }
};
export const EMPTY_PRICE_RANGES = {
    ELEMENTARY: {
        lookup_key: null
    },
    MIDDLE_SCHOOL: {
        lookup_key: null
    },
    HIGH_SCHOOL: {
        lookup_key: null
    }
};
export const TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL = 50;
export const FREE_TRIAL_DAYS = 7;
export const LOCAL_PLAN_NAMES = {
    'annual-individual': 'annual-individual',
    'annual-enterprise': 'annual-enterprise',
    'semi-annual-individual': 'semi-annual-individual',
    'semi-annual-free-trial': 'semi-annual-free-trial',
    'annual-free-trial': 'annual-free-trial'
};
